module.exports = __webpack_public_path__ + "img/play-ico.a4398425.svg";